import React from 'react';
import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'

const getIntegerComponent = (value) => {
    return <>{parseFloat(value).toFixed(0)}</>
}

const Mismatches = (props) => {

    const today = new Date();
    const dataClient = {
            url: '/admin/reports/voice/mismatches/missing-client',
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            filterColumnWidth: 12,
            userFilterAdvanced: true,
            userfilter:
            [
                {
                    source: 'start_time',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'group_by_period',
                    label: 'Group by Period',
                    type: 'select',
                },
            ],
            metadata:[
                    {
                        label: 'id',
                        source: 'ID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Period Start',
                        source: 'period',
                        type: 'string',
                    },
                    {
                        label: 'Period End',
                        source: 'period_end',
                        type: 'string',
                    },
                    {
                        label: 'Total Calls',
                        source: 'total_calls',
                        type: 'text'
                    },
                    {
                        label: 'Calls with Duration',
                        source: 'calls_with_duration',
                        type: 'component',
                        component: getIntegerComponent
                    },
                    {
                        label: 'Total Minutes',
                        source: 'total_duration_minutes',
                        type: 'component',
                        component: getIntegerComponent
                    },
                    {
                        label: 'View Details',
                        source: 'view_details',
                        type: 'link',
                        value: '/admin/reports/voice/cdr?start_time_from={$period}&start_time_to={$period_end}&originating_carrier_id=0'
                    }
                ]
            }
        const dataRate = {
            url: '/admin/reports/voice/mismatches/missing-rate',
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            filterColumnWidth: 12,
            userFilterAdvanced: true,
            userfilter:
            [
                {
                    source: 'start_time',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'group_by_period',
                    label: 'Group by Period',
                    type: 'select',
                },
            ],
            metadata:[
                    {
                        label: 'id',
                        source: 'ID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Period Start',
                        source: 'period',
                        type: 'string',
                    },
                    {
                        label: 'Period End',
                        source: 'period_end',
                        type: 'string',
                    },
                    {
                        label: 'Total Calls',
                        source: 'total_calls',
                        type: 'text'
                    },
                    {
                        label: 'Calls with Duration',
                        source: 'calls_with_duration',
                        type: 'component',
                        component: getIntegerComponent
                    },
                    {
                        label: 'Total Minutes',
                        source: 'total_duration_minutes',
                        type: 'component',
                        component: getIntegerComponent
                    },
                    {
                        label: 'View Details',
                        source: 'view_details',
                        type: 'link',
                        value: '/admin/reports/voice/cdr?start_time_from={$period}&start_time_to={$period_end}&sell_rate_item_id=0'
                    }
                ]
            }
    return (
        <div className="row">
            <div className="col-md-6">
                <Panel title = "Calls with missing Client">
                    <DataResource
                        data = {dataClient}
                        {...props} 
                    />
                </Panel>
            </div>
            <div className="col-md-6">
                <Panel title = "Calls with missing Rate">
                    <DataResource
                        data = {dataRate}
                        {...props} 
                    />
                </Panel>
            </div>
        </div>
    );
};

export default Mismatches;